export class RestorePasswordModel {
    email: string;
    restoreCode: string;
    newPassword: string;
    newPasswordCheck: string;
}
